import React from 'react';
import { Path } from 'react-native-svg';

export const TopTriangle = ({ popupConfig, popupWidth, popupHeight, C, fill = 'Background/Light/Modal Highlight', borderRadius = 12 }) => {
  const triangleCenter = popupConfig.elementPosition.left;
  const triangleSizeConfig = 6.48528;
  const triangleWidth = 30;

  const hideTriangleLeftCorner = triangleCenter - triangleWidth / 2 < 5;
  const hideTriangleRightCorner = triangleCenter + triangleWidth / 2 > popupWidth - 5;

  return (
    <Path
      d={`
        M${triangleCenter + triangleSizeConfig} ${triangleSizeConfig}
        L${triangleCenter} 0
        L${triangleCenter - triangleSizeConfig} ${triangleSizeConfig}
        C${triangleCenter - 8.736} 8.73572 ${triangleCenter - 11.788} 10 ${triangleCenter - 14.971} 10
        L${triangleCenter - 20} 10
        L${hideTriangleLeftCorner ? 0 : borderRadius} 10
        ${hideTriangleLeftCorner ? '' : `A${borderRadius} ${borderRadius} 0 0 0 0 ${10 + borderRadius}`}
        V${popupHeight - borderRadius}
        A${borderRadius} ${borderRadius} 0 0 0 ${borderRadius} ${popupHeight}
        H${popupWidth - borderRadius}
        A${borderRadius} ${borderRadius} 0 0 0 ${popupWidth} ${popupHeight - borderRadius}
        V${10 + borderRadius}
        ${hideTriangleRightCorner ? '' : `A${borderRadius} ${borderRadius} 0 0 0 ${popupWidth - borderRadius} 10`}
        H${triangleCenter + 20}
        L${triangleCenter + 14.971} 10
        C${triangleCenter + 11.788} 10 ${triangleCenter + 8.736} 8.73571 ${triangleCenter + 6.485} 6.48528
        Z
      `}
      fill={C(fill)}
    />
  );
};

export const BottomTriangle = ({ popupConfig, popupWidth, popupHeight, C, fill = 'Background/Light/Modal Highlight', borderRadius = 12, }) => {
  const triangleCenter = popupConfig.elementPosition.left;
  const triangleSizeConfig = 6.48528;
  const triangleConfig = popupHeight - 6.48528;
  const triangleOffset = popupHeight - 10;
  const triangleWidth = 30;

  const hideTriangleLeftCorner = triangleCenter - triangleWidth / 2 < 5;
  const hideTriangleRightCorner = triangleCenter + triangleWidth / 2 > popupWidth - 5;

  return (
    <Path
      d={`
        M${triangleCenter + triangleSizeConfig} ${triangleConfig}
        L${triangleCenter} ${popupHeight}
        L${triangleCenter - triangleSizeConfig} ${triangleConfig}
        C${triangleCenter - 8.736} ${popupHeight - 8.73572} ${triangleCenter - 11.788} ${triangleOffset} ${triangleCenter - 14.971} ${triangleOffset}
        L${triangleCenter - 20} ${triangleOffset}
        L${hideTriangleLeftCorner ? 0 : borderRadius} ${triangleOffset}
        ${hideTriangleLeftCorner ? '' : `A${borderRadius} ${borderRadius} 0 0 1 0 ${triangleOffset - borderRadius}`}
        V${borderRadius}
        A${borderRadius} ${borderRadius} 0 0 1 ${borderRadius} 0
        H${popupWidth - borderRadius}
        A${borderRadius} ${borderRadius} 0 0 1 ${popupWidth} ${borderRadius}
        V${triangleOffset - borderRadius}
        ${hideTriangleRightCorner ? '' : `A${borderRadius} ${borderRadius} 0 0 1 ${popupWidth - borderRadius} ${triangleOffset}`}
        H${triangleCenter + 20}
        L${triangleCenter + 14.971} ${triangleOffset}
        C${triangleCenter + 11.788} ${triangleOffset} ${triangleCenter + 8.736} ${triangleOffset + 1.26429} ${triangleCenter + 6.485} ${
        triangleOffset + 3.51472
      }
        Z
      `}
      fill={C(fill)}
    />
  );
};
